export default {"src":"/_next/static/media/headway-logo-white.47575e66.svg","height":2784,"width":2841,"blurWidth":0,"blurHeight":0};